
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class TheNoticeAlert extends Vue {
  @Prop() message!: string | null
  @Prop() title!: string | null
  @Prop({ default: 'fa-exclamation-triangle' }) icon!: string | null
}
